<template>
  <div>
    <TipsAlert :tipswords="masterTips.tipswords"
               :status="masterTips.status"
               :videostatus="masterTips.videostatus"
               :videosrc="masterTips.videosrc">

    </TipsAlert>

    <b-card no-body :header="'加分黃金號碼'" class="mb-2" border-variant="primary" header-bg-variant="primary"
            header-text-variant="white">
      <div class="px-2">
        <p class="text-center mt-3">黃金號碼點選次數 <span class="text-danger h3">  {{ goldNumber }}</span>
          (如選擇倍增屬性則扣<span class="text-danger ">2</span>次）</p>
        <div v-for="(item , index) in goldItem.one" v-bind:key="index+'one'"  @click="checkedControl('one',index+'one')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>
        <hr>
        <div v-for="(item , index) in goldItem.two" v-bind:key="index+'two'"  @click="checkedControl('two',index+'two')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>

        <hr>
        <div v-for="(item , index) in goldItem.three" v-bind:key="index+'three'"  @click="checkedControl('three',index+'three')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>

        <hr>
        <div v-for="(item , index) in goldItem.four" v-bind:key="index+'four'"  @click="checkedControl('four',index+'four')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>

        <hr>
        <div v-for="(item , index) in goldItem.five" v-bind:key="index+'five'"  @click="checkedControl('five',index+'five')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>

        <hr>
        <div v-for="(item , index) in goldItem.six" v-bind:key="index+'six'"  @click="checkedControl('six',index+'six')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>
        <hr>
        <div v-for="(item , index) in goldItem.night" v-bind:key="index+'night'"  @click="checkedControl('night',index+'night')" class="m-1"
             :class="item.checked?'border d-inline-flex rounded-pill p-2 bg-primary text-white':'border d-inline-flex rounded-pill p-2  '"  >{{ item.name }}</div>
        <hr>

      </div>

    </b-card>

    <b-button pill block variant="primary" size="lg" class="text-white shadow-lg mb-3" style=" background: linear-gradient(180deg, rgba(215,176,128,1) 0%, rgba(164,120,85,1) 100%)" @click="callaction">分析取得黃金號碼</b-button>

  </div>

</template>


<script>
import {alertModel,toastsModel} from '@/service/commuse'
import TipsAlert from '@/components/TipsAlert.vue'

export default {
  name: 'PickGoldNumber',
  props: {

  },
  components: {TipsAlert},
  data() {
    return {
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'（黃金號碼）每個數字都蘊含著，為人不知的數字密碼，從0到９，都有它特殊意義，選擇自己的需求，配對出最適合自己的號碼，幫自己在人際與財運之間增加好運勢。',
      },
      picker:[],
      goldNumber:7,
      goldItem:{
        one:[
          {
            name: '增加知心閨蜜',
            key: '增加知心閨蜜',
            value:1,
            checked:false
          },
          {
            name: '知心閨蜜倍增',
            key: '知心閨蜜倍增',
            value:2,
            checked:false
          },
        ],
        two:[
          {
            name: '增加同性貴人',
            key: '增加同性貴人',
            value:1,
            checked:false
          },
          {
            name: '同性貴人倍增',
            key: '同性貴人倍增',
            value:2,
            checked:false
          }
        ],
        three:[
          {
            name: '增加異性貴人',
            key: '增加異性貴人',
            value:1,
            checked:false

          },
          {
            name: '異性貴人倍增',
            key: '異性貴人倍增',
            value:2,
            checked:false
          }
        ],
        four:[
          {
            name: '增加財庫',
            key: '增加業務',
            value:1,
            checked:false

          },
          {
            name: '財庫倍增',
            key: '財庫倍增',
            value:2,
            checked:false

          }
        ],
        five:[
          {
            name: '增加偏財',
            key: '增加偏財',
            value:1,
            checked:false
          },
          {
            name: '偏財倍增',
            key: '偏財倍增',
            value:2,
            checked:false
          },
          {
            name: '偏財再倍增',
            key: '偏財再倍增',
            value:3,
            checked:false
          }
        ],
        six:[
          {
            name: '增加專業',
            key: '增加專業',
            value:1,
            checked:false

          },
          {
            name: '專業倍增',
            key: '專業倍增',
            value:2,
            checked:false
          },
          {
            name: '專業再倍增',
            key: '專業再倍增',
            value:3,
            checked:false
          }
        ],
        seven:[
          {
            name: '玩股票加強',
            key: '玩股票加強',
            value:3,
            checked:false

          },
        ],
        eight:[
          {
            name: '升官發財',
            key: '升官發財',
            value:4,
            checked:false

          },
        ],
        night:[
          {
            name: '增加業務',
            key: '增加專業',
            value:1,
            checked:false

          },
          {
            name: '業務倍增',
            key: '業務倍增',
            value:2,
            checked:false
          },
          {
            name: '業務再倍增',
            key: '業務再倍增',
            value:3,
            checked:false
          }
        ],
      }

    }
  },
  methods: {
    checkedControl(way,indexx){

      let index =parseInt(indexx)

        if(this.goldItem[way][index].checked){
          this.goldItem[way].forEach(i => {
            if(i.checked ){
              this.goldNumber += i.value;
              i.checked = false
              this.picker.splice(this.picker.indexOf(i.key),1);
            }
          })
          this.goldItem[way][index].checked=false
        }else{
          if( this.goldNumber >=  this.goldItem[way][index].value) {
            this.goldItem[way].forEach(i => {
              if (i.checked) {
                this.goldNumber += i.value;
                i.checked = false
                this.picker.splice(this.picker.indexOf(i.key),1);
              }
            })
            this.goldItem[way][index].checked = true
            this.goldNumber -= this.goldItem[way][index].value;
            this.picker.push( this.goldItem[way][index].key);
          }else if(this.goldNumber < this.goldItem[way][index].value){
            toastsModel(this,'剩餘 '+this.goldNumber+' 選擇次數，選擇次數不足')
          }

        }


    },
    callaction () {
     if( this.goldNumber !==0 ){
       alertModel(this,'系統訊息','尚有黃金號碼選項可以選擇')
     }else{
       this.$emit('sendAction',this.picker);
     }

    },

  }
}
</script>
